import { getApiEndpoint } from '@/utils/apiEndpoint';

const baseAxiosConfig = {
  timeout: 10 * 1000, // 10초
  headers: {
    'Content-Type': 'application/json',
  },
};

/**
 * 관리자(/admin) 전용 설정
 * - Bearer 토큰 + 쿠키를 함께 전송한다.
 */
export const axiosConfig = {
  ...baseAxiosConfig,
  baseURL: getApiEndpoint(),
  withCredentials: true,
};

/**
 * 공개 페이지 전용 설정
 * - 로그인이 필요없는 요청이므로 자격증명(쿠키)을 전송하지 않는다.
 */
export const publicAxiosConfig = {
  ...baseAxiosConfig,
  baseURL: getApiEndpoint(),
  withCredentials: false,
};
